import {useContext, useEffect, useRef} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import {BackButton} from './BackButton';
import './ScenePage.css';
import * as PIXI from 'pixi.js';
import * as PIXIMC from 'pixi-mc';

export function ScenePage()
{
	const closure = useContext(AppContext);
	const h2 = Utils.tr('SCENE_H2');
	const s1 = Utils.tr('SCENE_S1');
	const s2 = Utils.tr('SCENE_S2');
	// const homeBtnText = Utils.tr('HOME_BACK_BTN');

	const onBtnClick = (evt) =>
	{
		let target = evt.currentTarget;
		let scene = target.getAttribute('data-index') === '0' ? 'courses' : 'careers';
		closure.dispatch({type: 'push', page: 'start', args: {scene}});
	};

	const onBackBtnClick = () =>
	{
		//closure.dispatch({type: 'pop'});
        window.history.back();
	};

	const pixiRef = useRef();
	const emitter = closure.emitter;
	useEffect(() =>
	{
		const div = pixiRef.current;
		const pixi = new PIXI.Application({
			backgroundAlpha: 0,
			width: 200,
			height: 300
		});
		
		pixi.renderer.view.style.touchAction = 'auto';
		div.appendChild(pixi.view);

		const basePath = process.env.PUBLIC_URL + '/images/';
		
		PIXIMC.MCLoader.autoLoadModel(basePath + '/yy/', 1).then((model) =>
		{
			if(pixi.stage)
			{
				const cont = new PIXI.Container();
				PIXIMC.MCPlayer.getInstance().fps = 18;	
				let yy = new PIXIMC.MC(model.mainSymbolModel);
				yy = model.makeInstance();
				cont.addChild(yy);
				pixi.stage.addChild(cont);
				cont.position.set(10, 0);

				const animate = () =>
				{
					
				};

				const viewport = document.getElementsByClassName('view-port')[0];
				if(viewport)
				{
					if(viewport.classList.contains('is-animating'))
					{
						let wrapper = () =>
						{
							viewport.removeEventListener('transitionend', wrapper);
							animate();
						};
						viewport.addEventListener('transitionend', wrapper);
					}
					else
					{
						animate();
					}
				}
			}
		});

		const onHide = ({page}) =>
		{
			if(page.id === 'scene' && pixi.ticker)
			{
				pixi.ticker.stop();
			}
		};
		const onShow = ({action, page}) =>
		{
			if(action !== 'jump' && page.id === 'scene' && pixi.ticker)
			{
				pixi.ticker.start();
			}
		};

		emitter.on('hide', onHide);
		emitter.on('show', onShow);

		return () =>
		{
			// pixi.view.parentNode.removeChild(pixi.view);
			pixi.destroy(true);
			emitter.off('hide', onHide);
			emitter.off('show', onShow);
		};

	}, [emitter]);

	return (
		<>
			<div className="c-body">
				<h4 className="title is-4 has-text-centered mb-6">{h2}</h4>
				<div className="navigation columns">
					<div className="column is-6">
						<button data-index="0" onClick={onBtnClick} className="button is-primary style-btn is-size-4">
							<span>{s1}</span>
							<i className="fa fa-flask-vial"></i>
						</button>
					</div>
					<div className="column is-6">
						<button data-index="1" onClick={onBtnClick} className="button is-primary style-btn is-size-4">
							<span>{s2}</span>
							<i className="fa fa-briefcase"></i>
						</button>
					</div>
				</div>
				<div className="block t-illusion" ref={pixiRef}></div>
			</div>
			<div className="navigation">
				<div className="block has-text-centered">
					<BackButton onClick={onBackBtnClick} />
				</div>
			</div>
		</>
	);
}
